/**
 * 体检中心相关路由
 */
export default [
  /**
   * 体检中心首页
   */
  {
    path: '/check/index',
    component: () => import('../pages/check/index.vue')
  },
  {
    path: '/check/article/:id',
    props: true,
    component: () => import('../pages/check/details.vue')
  },
  /**
   * 走进中心
   * query
   * ****
   * ****
   */
  {
    path: '/check/center',
    component: () => import('../pages/check/center.vue')
  },
  /**
   * 报告解读
   * query
   * ****
   * ****
   */
  {
    path: '/check/explain',
    meta: {
      keepAlive: true
    },
    component: () => import('../pages/check/explain.vue')
  },
  /**
   * 图文咨询
   * query
   * ****
   * ****
   */
  {
    path: '/book/ask',
    component: () => import('../pages/check/ask.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/check.js